export default "__VITE_ASSET__Cu08VgIl__"